import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CreateNoteInput, NoteResponse } from '@orion/contracts';
import { api } from '../../lib/api-client.js';

interface NotesFilter {
  leadId?: string;
  contactId?: string;
  companyId?: string;
  opportunityId?: string;
  taskId?: string;
}

function queryString(filter: NotesFilter): string {
  const params = new URLSearchParams(filter as Record<string, string>);
  return `?${params.toString()}`;
}

export function useNotesQuery(filter: NotesFilter) {
  return useQuery({
    queryKey: ['notes', filter],
    queryFn: () => api.get<NoteResponse[]>(`/notes${queryString(filter)}`),
  });
}

export function useCreateNote(filter: NotesFilter) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateNoteInput) => api.post<NoteResponse>('/notes', input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notes', filter] }),
  });
}
